import formAjax from './form-ajax';
import {fieldValidate, valdateCaptcha} from './field-validate';

(function () {
	const forms = [].slice.call(document.querySelectorAll('.js-form-validate'));

	forms.forEach(form => {
		const fields = [].slice.call(form.querySelectorAll('.form__input, .form__textarea, .form__multi-select, .checkbox__input, .form__radio-buttons-group'));

		fields.forEach(field => {
			if (field.classList.contains('form__input__login')) return;
			if (field.type === 'tel') {
				field.addEventListener('keyup', () => {
					field.value = field.value.replace(/[^\d+() ]/g, '');
				});
			}

			field.addEventListener('change', () => {
				fieldValidate(field);
			});
		});

		form.addEventListener('submit', event => {
			event.preventDefault();
			fields.forEach(fieldValidate);
			valdateCaptcha(form);

			if (!form.querySelector('input[name="__RequestVerificationToken"]')) {
				form.appendChild(document.querySelector('input[name="__RequestVerificationToken"]'));
			}

			const countErrors = form.querySelectorAll('.form__error-field').length;
			const messageForm = form.querySelector('.form__message');

			messageForm.innerHtml = '';

			if (countErrors === 0) {
				if (form.classList.contains('js-form-confirm')) {
					// eslint-disable-next-line no-use-before-define
					const result = window.confirm('Are you sure you want to delete this user?');

					if (!result) {
						return;
					}
				}
				if (form.classList.contains('js-form-ajax')) {
					formAjax(form);
				} else {
					form.submit();
				}
			} else {
				const errorElement = form.querySelector('.form__error-field');

				errorElement.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			}
		});
	});
}());
